import React, { useRef, useState } from 'react'
import Header from '../../components/global/Header'
import styles from "../../asset/css/daoPage.module.css";
import { Images } from '../../data/Images';
import "swiper/css";
import { Swiper, SwiperSlide } from "swiper/react";
import { ImageComponent } from '../../components/global/ThemeImg';
export default function WorksPage() {
    const imgSwiperRef = useRef(null);
    const contentSwiperRef = useRef(null);
    const [activeIndex, setActiveIndex] = useState(0);
    const sliderContent = [
        {
            cardTitle: "Connect your wallet",
            cardContent: {
                title: "Connect your wallet",
                text: "Ensure you have a Solana-compatible wallet (Phantom wallet)",
                lists: []
            }
        },
        {
            cardTitle: "Browse Upcoming Projects",
            cardContent: {
                title: "Browse Upcoming Projects",
                text: "",
                lists: [
                    "-Explore the list of verified high-quality projects launching soon.",
                    "-Click on a project to view details, including its whitepaper, website, tokenomics, and funding goals."
                ]

            }
        },
        {
            cardTitle: "Fund your wallet",
            cardContent: {
                title: "Fund your wallet",
                text: "",
                lists: [
                    "-Ensure you have USDC (Solana) to participate in the fair launch",
                    "-You may also need SOL for network fees."
                ]

            }
        },
        {
            cardTitle: "Invest in a Fair Launch Token",
            cardContent: {
                title: "Review & Approval Process",
                text: "",
                lists: [
                    "-During the launch window, enter the amount of USDC you want to invest.",
                    "-Confirm your investment and sign the transaction with your wallet.",
                    "-All users participate fairly—no private sales, no VC allocations."
                ]

            }
        },
        {
            cardTitle: "Claim your Tokens",
            cardContent: {
                title: "Launch on Nexus",
                text: "",
                lists: [
                    "-After the fair launch concludes, tokens are distributed proportionally based on total contributions.",
                    "-Claim your project tokens directly from the Nexus Launchpad interface."
                ]

            }
        },
        {
            cardTitle: "Trade, Stake & participate",
            cardContent: {
                title: "Trade, Stake & participate",
                text: "",
                lists: [
                    "-Your tokens can be used for staking, trading, governance, or other utilities in the project.",
                    "-Follow the project’s roadmap and updates for future developments."
                ]
            }
        }
    ]
    const handleSlideChange = (index) => {
        setActiveIndex(index);
        if (imgSwiperRef.current) imgSwiperRef.current.slideTo(index);
        if (contentSwiperRef.current) contentSwiperRef.current.slideTo(index);
    };
    return (
        <div className={`${styles.deoPage} ${styles.aiPage} ${styles.applyListPage} ${styles.worksPage} homePagelayout`}>
            <Header />
            <section className={styles.tokenomicsSection}>
                <div className={styles.titlePart}>
                    <h2 className={"madani_arabic_bold"}>How it works</h2>
                    <h3><strong>How It Works: </strong>Investing in Projects on Nexus Launchpad</h3>
                    <p>
                        Nexus Launchpad offers a fair and transparent way for users to invest in high-quality projects built on Solana. Follow these steps to participate in launches and invest in upcoming projects.
                    </p>
                </div>
                <div className={styles.contentPart}>
                    <div className={styles.sliderContent}>
                        <div className={styles.applySliderBtnList}>
                            <ul>
                                {
                                    sliderContent.map((item, i) => (
                                        <li key={i}>
                                            <button className={activeIndex == i ? `${styles.active}` : ""} onClick={() => handleSlideChange(i)}>
                                                {item.cardTitle}
                                            </button>
                                        </li>
                                    ))
                                }
                            </ul>
                        </div>
                        <div className={styles.applySliderBody}>
                            <div className={styles.contentPart}>
                                <Swiper onSwiper={(swiper) => (contentSwiperRef.current = swiper)} spaceBetween={20} speed={2000} allowTouchMove={false} className="digitalSliderContent">
                                    {
                                        sliderContent.map((item, i) => (
                                            <SwiperSlide key={i} className={styles.contentSwiperSlide}>
                                                <div className={styles.cardHeader}>
                                                    <h3>{item.cardContent.title}</h3>
                                                </div>
                                                <div className={styles.cardBody}>
                                                    <p>{item.cardContent.text}</p>
                                                    <ul>
                                                        {item.cardContent.lists.map((item) => (
                                                            <li>{item}</li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            </SwiperSlide>
                                        ))
                                    }
                                </Swiper>
                            </div>
                        </div>
                    </div>
                    <div className={styles.whyChooseNexus}>
                        <div className={styles.headerPart}>
                            <h2>Why choose Nexus? </h2>
                        </div>
                        <div className={styles.bodyPart}>
                            <div className={styles.cardPart}>
                                <ImageComponent staticImgSrc={"whyNexuIcon1"} />
                                <div>
                                    <h3>fair launch</h3>
                                    <p>No VC advantage, equal access for all.</p>
                                </div>
                            </div>
                            <div className={styles.cardPart}>
                                <ImageComponent staticImgSrc={"whyNexuIcon2"} />
                                <div>
                                    <h3> Secure & Verified</h3>
                                    <p>Only high-quality projects are listed.
                                    </p>
                                </div>
                            </div>
                            <div className={styles.cardPart}>
                                <ImageComponent staticImgSrc={"whyNexuIcon3"} />
                                <div>
                                    <h3>Community-Driven</h3>
                                    <p>Supporting the next wave of web3 innovation.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={styles.footerPart}>
                        <p>
                            Start investing in the future of Web3 today!
                        </p>
                    </div>
                </div>
                <div className={styles.tokenBgPatten}>
                    <img className={styles.aiPattenImg1} src={Images.aiPattenImg1} alt="circle Shape" />
                    <img className={styles.aiPattenImg2} src={Images.aiPattenImg2} alt="circle Shape" />
                    <img className={styles.aiPattenImg3} src={Images.aiPattenImg3} alt="circle Shape" />
                    <img className={styles.aiPattenImg4} src={Images.aiPattenImg4} alt="circle Shape" />
                    <img className={styles.aiPattenImg5} src={Images.aiPattenImg5} alt="circle Shape" />
                </div>
            </section >
        </div >
    )
}
